var render = function render(_c,_vm){return _c('li',{staticClass:"user-dropdown-item",on:{"click":_vm.listeners.click}},[(_vm.props.icon !== null)?_c('font-awesome-icon',{staticClass:"user-dropdown-icon",attrs:{"icon":_vm.props.icon,"fixed-width":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }